import { render, staticRenderFns } from "./QueryGroup.vue?vue&type=template&id=3b718d22&"
import script from "./QueryGroup.vue?vue&type=script&lang=js&"
export * from "./QueryGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports